module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card yellow"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content fetch",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [(_vm.hasResults) ? _c('div', [_c('table', {
    staticClass: "yellow"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.rankings), function(ranking, index) {
    return (ranking !== null) ? _c('tr', [_c('td', [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(_vm.labels[index].icon))]), _vm._v("  " + _vm._s(_vm.labels[index].plural))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ranking.rank) + _vm._s(ranking.rank === 1 ? 'st' : '') + _vm._s(ranking.rank === 2 ? 'nd' : '') + _vm._s(ranking.rank === 3 ? 'rd' : '') + _vm._s(ranking.rank > 3 ? 'th' : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(ranking.amount).toLocaleString('en-US')))])]) : _vm._e()
  }), 0)])]) : _c('div', [_c('p', [_vm._v("No results that match those filters.")])])]), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-wrap center",
    class: [{
      'is-loading': _vm.isLoading
    }]
  }, [_c('LoaderDots')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "card-h2"
  }, [_c('span', [_vm._v("Who")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Metric")]), _vm._v(" "), _c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e284683c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/WhoRank.vue
// module id = 455
// module chunks = 1